module.exports = __webpack_public_path__ + "assets/images/figurine_herbert.e117846.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines/figurine_herbert.png
// module id = 353
// module chunks = 1